const ROOT_KEY = 'personalization'

export const personalizationKeys = {
  all: [ROOT_KEY] as const,
  personalizations: (accountId: string) =>
    [ROOT_KEY, 'personalizations', accountId] as const,
  filters: [ROOT_KEY, 'filters'] as const,
  selectedFilters: [ROOT_KEY, 'selectedFilter'] as const,
  graphs: [ROOT_KEY, 'graphs'] as const,
  variants: (accountId: string) => [ROOT_KEY, 'variants', accountId] as const,
  customerAttributes: (accountId: string) =>
    [ROOT_KEY, 'customerAttributes', accountId] as const,
  productCategories: (accountId: string) =>
    [ROOT_KEY, 'productCategories', accountId] as const,
}
